<form class="form" [formGroup]="form">
  <h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
  <mat-dialog-content *ngIf="message">
    {{ message }}
    <mat-form-field class="full-width" appearance="outline">
      <textarea
        matInput
        cdkFocusInitial
        formControlName="justification"
        placeholder="Qual a justificativa para reprovar?"
        maxlength="1000"
        data-cy="justification"
        maxlength="1000"
        name="justification"
        rows="4"
        required
      ></textarea>      
    </mat-form-field>
    <span class="text-right">{{ form.get('justification').value.length }}/1000 caracteres</span>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Não</button>
    <button mat-button (click)="confirmRejection()">Sim</button>
  </mat-dialog-actions>
</form>
